const LANGUAGE_CACHE_KEY = "teams-app-language";

export const getCachedLanguage = (): string | null => {
  try {
    return localStorage.getItem(LANGUAGE_CACHE_KEY);
  } catch (error) {
    console.warn("Could not access localStorage for language cache:", error);
    return null;
  }
};

export const setCachedLanguage = (languageCode: string): void => {
  try {
    localStorage.setItem(LANGUAGE_CACHE_KEY, languageCode);
  } catch (error) {
    console.warn("Could not cache language preference:", error);
  }
};

export const isLocaleMatchingCache = (teamsLocale: string): boolean => {
  const cachedLang = getCachedLanguage();
  if (!cachedLang || !teamsLocale) return false;

  const normalizedTeamsLocale = teamsLocale.toLowerCase();
  const normalizedCachedLang = cachedLang.toLowerCase();

  if (normalizedCachedLang === normalizedTeamsLocale) {
    return true;
  }

  const teamsLangCode = normalizedTeamsLocale.split("-")[0];

  if (normalizedCachedLang === teamsLangCode) {
    return true;
  }

  const cachedLangCode = normalizedCachedLang.split("-")[0];

  return cachedLangCode === teamsLangCode;
};
